import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import Cloud from '@/components/Cloud'

Vue.use(Router)

export default new Router({
    // mode: 'history',
    routes: [{
        path: '/',
        name: 'Login',
        component: Login,
    }, {
        path: '/cloud',
        name: 'Cloud',
        component: Cloud,
        // meta: {
        //     requireAuth: true
        // },
        beforeEnter: function(to, from, next) {
            // if (to.meta.requireAuth) {
            if (sessionStorage.getItem("token") + '' === 'true') {
                next();
            } else {
                // var record = localStorage.getItem('record');
                // if (record + '' === 'true') {
                //     next();
                // } else {
                //     next('/');
                // };
                next('/');
                window.location.reload(true);
            };
            // } else {
            //     next();
            // };
        }
    }, {
        path: '/*',
        beforeEnter: function(to, from, next) {
            if (to.path.replace('/cloud', '') === '') {
                next('/cloud');
            } else {
                next('/');
                console.log('jump error');
            };
        },
        // redirect: './'
    }]
})


// WEBPACK FOOTER //
// ./src/router/index.js